


























































import {
  SfLink, SfList, SfIcon
} from '@storefront-ui/vue';
import { defineComponent, ref, onMounted } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { CategoryTree } from '~/modules/GraphQL/types';
import { useUiHelpers } from '~/composables';
import type { ComponentTemplateRef } from '~/types/componentTemplateRef';

export default defineComponent({
  name: 'HeaderNavigationSubcategories',
  components: {
    SfLink,
    SfList,
    SfIcon
  },
  props: {
    currentCategory: {
      type: Object as PropType<CategoryTree | null>,
      default: () => null,
    },
    hasFocus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { getCatLink } = useUiHelpers();
    const lvl1CatRefs = ref<ComponentTemplateRef[]>();
    const lvl2CatRefs = ref<ComponentTemplateRef[]>();
    const lvl2GroupedCatRefs = ref<ComponentTemplateRef[][]>();

    const hasChildren = (category: CategoryTree) => Boolean(category?.children.length > 0);

    const getGroupedLvl2CatRefs = () : ComponentTemplateRef[][] => {
      let current = 0;
      const result : ComponentTemplateRef[][] = [];
      lvl1CatRefs.value.forEach((lvl1CatRef) => {
        const groupCount = Number(lvl1CatRef.$el.dataset.children);
        const group = lvl2CatRefs.value.slice(current, current + groupCount);
        result.push(group);
        current += groupCount;
      });

      return result;
    };

    // Once submenu is opened we start from the very first element
    let lvl1CatFocusIdx = 0;
    // We start from the "outside" of lvl2Cats, navigation action must be performed to jump into lvl2CatTree
    let lvl2CatFocusIdx = -1;

    const navRight = () => {
      if (lvl1CatRefs.value[++lvl1CatFocusIdx]) {
        lvl1CatRefs.value[lvl1CatFocusIdx].$el.focus();
        lvl2CatFocusIdx = -1;
        lvl2GroupedCatRefs.value = getGroupedLvl2CatRefs();
      } else {
        lvl1CatFocusIdx--;
      }
    };

    const navLeft = () => {
      if (lvl1CatRefs.value[--lvl1CatFocusIdx]) {
        lvl1CatRefs.value[lvl1CatFocusIdx].$el.focus();
        lvl2CatFocusIdx = -1;
        lvl2GroupedCatRefs.value = getGroupedLvl2CatRefs();
      } else {
        lvl1CatFocusIdx++;
      }
    };

    const navDown = () => {
      lvl2CatFocusIdx++;
      if (lvl2CatFocusIdx !== -1 && !lvl2GroupedCatRefs.value[lvl1CatFocusIdx][lvl2CatFocusIdx]) {
        lvl2CatFocusIdx--;
        return;
      }
      lvl2GroupedCatRefs.value[lvl1CatFocusIdx][lvl2CatFocusIdx].$el.focus();
    };

    const navUp = () => {
      if (lvl2CatFocusIdx > 0) {
        lvl2CatFocusIdx--;
        lvl2GroupedCatRefs.value[lvl1CatFocusIdx][lvl2CatFocusIdx].$el.focus();
        return;
      }

      if (lvl2CatFocusIdx === 0) {
        lvl1CatRefs.value[lvl1CatFocusIdx].$el.focus();
        lvl2CatFocusIdx = -1;

        return;
      }

      if (lvl2CatFocusIdx === -1) {
        emit('hideSubcategories');
      }
    };

    const setupNav = () => {
      lvl2CatFocusIdx = -1;
      lvl1CatRefs.value[lvl1CatFocusIdx].$el.focus();
      lvl2GroupedCatRefs.value = getGroupedLvl2CatRefs();
    };

    onMounted(() => {
      if (props.hasFocus) {
        setupNav();
      }
    });

    return {
      getCatLink,
      hasChildren,
      navRight,
      navLeft,
      navDown,
      navUp,
      setupNav,
      lvl1CatRefs,
      lvl2CatRefs,
    };
  },
});
